import { Station } from "../domain/types";
import { ApiPortEntry, ApiViewEntry } from "../domain/visuals/SearchControl";
import { apiGet } from "./api";


export async function fetchStations(view: string | null = null): Promise<Station[] | null> {
	if (view) {
		return apiGet<Station[]>("config/stations?view=" + view);
	}
	return apiGet<Station[]>("config/stations");
}
export async function getStatus(): Promise<any> {
	return apiGet<any[]>("config/status");
}
export async function getPorts(): Promise<Array<ApiPortEntry> | null> {
	return apiGet<any[]>("config/ports");
}
export async function getViews(): Promise<Array<ApiViewEntry> | null> {
	return apiGet<any[]>("config/views");
}
export async function getView(view: string): Promise<ApiViewEntry | null> {
	if (!view) {
		return null;
	}
	return apiGet<any>("config/view/" + view);
}